import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../../utils/requestHeaders";
import { API_HOST } from "../../utils/constants";
import { buildMutationHelper } from "../../utils/buildMutationHelper";
import { defaultFromState } from "../../utils/defaultFromState";
import { setClientDepartment } from "../reducer/clientDepartment";

export const clientDepartmentApi = createApi({
  reducerPath: "clientDepartmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
  }),

  endpoints: (builder) => ({
    getClientDepartmentList: buildMutationHelper(
      builder,
      ({
        page = undefined,
        itemsPerPage = undefined,
        pagination = undefined,
      } = {}) => {
        return {
          url: "/client-departments",
          params: {
            page: page,
            itemsPerPage: itemsPerPage,
            pagination: pagination,
          },
          method: "GET",
          headers: getHeaders(),
          defaultFromState: (getState, args) => {
            const {
              externalSources: { page, itemsPerPage, pagination },
            } = getState();

            let stateParams = {
              page,
              itemsPerPage,
              pagination,
            };

            return defaultFromState(stateParams, args);
          },
        };
      },

      (response, dispatch) => {
        if (
          new URL(response?.meta?.request?.url).searchParams.get(
            "pagination"
          ) === null
        ) {
          const { data } = response?.data;
          const totalCount = response?.data?.totalItems;
          dispatch(
            setClientDepartment({
              data,
              totalCount,
              errorMessage: "",
            })
          );
        } else {
          const exportData = response?.data;
          dispatch(
            setClientDepartment({
              exportData,
              errorMessage: "",
            })
          );
        }
      },

      ({ error }, dispatch) => {
        dispatch(setClientDepartment({ errorMessage: error?.data?.error }));
      }
    ),
  }),
});
export const { useGetClientDepartmentListMutation } = clientDepartmentApi;
